import { currencies } from "@api/geo/currencies/path";

export const geo = {
  currencies,
};
